<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6496_22689)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M50 100C77.614 100 100 77.614 100 50C100 22.386 77.614 0 50 0C22.386 0 0 22.386 0 50C0 77.614 22.386 100 50 100Z" fill="white" fill-opacity="0.8"/>
<path d="M42.0791 32.5C43.6944 32.5001 45.0038 33.8095 45.0039 35.4248V64.5752C45.0038 66.1905 43.6944 67.4999 42.0791 67.5H37.9287C36.3134 67.4999 35.004 66.1905 35.0039 64.5752V35.4248C35.004 33.8095 36.3134 32.5001 37.9287 32.5H42.0791Z" fill="#161819"/>
<path d="M62.0791 32.5C63.6944 32.5001 65.0038 33.8095 65.0039 35.4248V64.5752C65.0038 66.1905 63.6944 67.4999 62.0791 67.5H57.9287C56.3134 67.4999 55.004 66.1905 55.0039 64.5752V35.4248C55.004 33.8095 56.3134 32.5001 57.9287 32.5H62.0791Z" fill="#161819"/>
</g>
<defs>
<clipPath id="clip0_6496_22689">
<rect width="100" height="100" rx="17.1429" fill="white"/>
</clipPath>
</defs>
</svg>
